<template>
    <div class="classify-name-config">
        <TitleBaseBox v-show="multiLanguage.length > 0" :title="title" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="content">
                <div class="item-config-edit" v-for="item in multiLanguage" :key="item.uId">
                    <div class="item-lable">{{ $t(item.i18nKey) }}</div>
                    <div class="item-input">
                        <input :placeholder="palceHolder" v-model="item.name" />
                    </div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";

export default {
    name: "ClassifyNameConfig",
    props: ["data"],
    components: {
        TitleBaseBox
    },
    data() {
        return {
            multiLanguage: []
        };
    },
    computed: {
        palceHolder() {
            return this.$t("zhiji.materialLibrary.enterClassify");
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        title() {
            return this.$t("zhiji.materialLibrary.classifyConfig");
        }
    },
    mounted() {
        this.getClassifyNameData();
    },
    methods: {
        // 获取多语言分类配置信息
        async getClassifyNameData() {
            await this.zhiji
                .requestByServiceName("queryMultiLanguage", {
                    tagId: this.data.tagId
                })
                .then(result => {
                    this.multiLanguage = result;
                });
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            // 保存多语言分类编辑
            this.zhiji
                .requestByServiceName("saveMultiLanguageEdit", {
                    tagId: this.data.tagId,
                    multiLanguage: this.multiLanguage
                })
                .then(() => {
                    this.close();
                });
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.classify-name-config {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .content {
        max-width: 1038px;
        background: #fff;
        .item-config-edit {
            border: 1px solid #d8e4f0;
            display: inline-flex;
            border-radius: 4px;
            margin: 0 8px 12px 0;
            vertical-align: top;
            padding: 0;
            .item-lable {
                position: relative;
                height: 32px;
                line-height: 1.2;
                display: inline-flex;
                align-items: center;
                box-sizing: border-box;
                width: 120px;
                padding: 4px 8px;
                &::after {
                    display: inline-block;
                    width: 1px;
                    height: 24px;
                    background: #d8e4f0;
                    position: absolute;
                    right: 0;
                    content: "";
                    top: 4px;
                }
            }
            .item-input {
                display: inline-flex;
                padding: 4px 8px;
                input {
                    width: 200px;
                }
            }
        }
    }
}
</style>
